/* es5-ext/object/valid-object */ function _(require, module, exports) {
    var isObject = require(346) /* ./is-object */;
    module.exports = function (value) {
        if (!isObject(value))
            throw new TypeError(value + " is not an Object");
        return value;
    };
}
